import { render, staticRenderFns } from "./TeamAnalysisTab.vue?vue&type=template&id=9132ae9a&scoped=true&"
import script from "./TeamAnalysisTab.vue?vue&type=script&lang=js&"
export * from "./TeamAnalysisTab.vue?vue&type=script&lang=js&"
import style0 from "./TeamAnalysisTab.vue?vue&type=style&index=0&id=9132ae9a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9132ae9a",
  null
  
)

export default component.exports